import { render, staticRenderFns } from "./PricingBreakdownSummary.template.vue?vue&type=template&id=6fa22ba8&scoped=true&"
var script = {}
import style0 from "./PricingBreakdownSummary.template.vue?vue&type=style&index=0&id=6fa22ba8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa22ba8",
  null
  
)

export default component.exports